<template>
  <MediaImage
    v-if="parentType"
    v-show="isVisible"
    :id
    v-bind="image"
    :responsive-style="responsiveStyle"
  />
  <section v-else v-show="isVisible" :id class="container">
    <MediaImage v-bind="image" :responsive-style="responsiveStyle" />
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphImageFragment } from '#graphql-operations'
import type { ResponsiveStyleName } from '~/helpers/responsiveStyles'

defineProps<ParagraphImageFragment>()

const { parentType, options, rootBlocks, index, siblings } = defineBlokkli({
  bundle: 'image',
  globalOptions: [
    'isHero',
    'contextToggleId',
    'bkHiddenGlobally',
    'publicationChannels',
  ],
  editor: {
    determineVisibleOptions: function (ctx) {
      if (ctx.parentType) {
        return ['contextToggleId', 'bkHiddenGlobally', 'publicationChannels']
      }

      return [
        'isHero',
        'contextToggleId',
        'bkHiddenGlobally',
        'publicationChannels',
      ]
    },
  },
})

const id = useParagraphAnchorId(index, siblings)
const { determineVisibility } = usePartyToggle()
const isVisible = determineVisibility(options, rootBlocks)

const responsiveStyle = computed<ResponsiveStyleName>(() => {
  if (!parentType.value) {
    return options.value.isHero ? 'content_fullwidth' : 'content_fullwidth_4_3'
  }

  return 'column_half'
})
</script>
